import axios from "../../../../api/axios";

import { CandidateReviewPayload } from "../../types/candidate";

import { Bucket } from "../../enum/jobEnums";
import {
  ReviewCandidateResponse,
  GetCandidateApplicationResponse,
  GetCandidateReviewResponse,
  CompareCandidatesPayload,
  CompareCandidatesResponse,
} from "../types/candidate.types";

type ReviewCandidateParams = {
  jobId: number | string;
  candidateId: number | string;
  payload: CandidateReviewPayload;
};

type ChangeCandidateStatusParams = {
  jobId: number | string;
  candidateId: number | string;
  payload: {
    bucket: Bucket;
  };
};

type GetCandidateApplicationParams = {
  jobId: number | string;
  candidateId: number | string;
};

type GetCandidateReviewParams = {
  jobId: number | string;
  candidateId: number | string;
};

export const reviewCandidate = async ({
  jobId,
  candidateId,
  payload,
}: ReviewCandidateParams): Promise<ReviewCandidateResponse> => {
  const response = await axios.put(`/hire-jobs/${jobId}/candidates/${candidateId}/bucket-review`, payload);
  return response.data;
};

export const changeCandidateStatus = async ({
  jobId,
  candidateId,
  payload,
}: ChangeCandidateStatusParams): Promise<ReviewCandidateResponse> => {
  const response = await axios.put(`/hire-jobs/${jobId}/candidates/${candidateId}/bucket`, payload);
  return response.data;
};

export const getCandidateApplication = async ({
  jobId,
  candidateId,
}: GetCandidateApplicationParams): Promise<GetCandidateApplicationResponse> => {
  const response = await axios.get(`/hire-jobs/${jobId}/candidates/${candidateId}/application`);
  return response.data;
};

export const getCandidateReview = async ({
  jobId,
  candidateId,
}: GetCandidateReviewParams): Promise<GetCandidateReviewResponse> => {
  const response = await axios.get(`/hire-jobs/${jobId}/candidates/${candidateId}/bucket-review`);
  return response.data;
};

export const compareCandidates = async (payload: CompareCandidatesPayload): Promise<CompareCandidatesResponse> => {
  const response = await axios.post("/hire-jobs/candidates/compare", payload);
  return response.data;
};
